module.exports = __webpack_public_path__ + "static/media/fiber.5a769e41.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fiber.svg
// module id = 253
// module chunks = 0